import { Typography } from '@mui/joy';
import { TrashSimple } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';

import { useAgGridClientTableContext } from 'core/states';
import { UnlinkProjectPricingProfileButton } from 'projects/components/ProjectDetails';
import { Color, Level } from 'theme/enums';

interface IProps extends ICellRendererParams {
  projectId: number;
}

export const ActionsCell = ({ data, projectId }: IProps) => {
  const { updateRows } = useAgGridClientTableContext();

  if (!data) {
    return null;
  }

  return (
    <UnlinkProjectPricingProfileButton
      pricingProfiles={[data]}
      projectId={projectId}
      onSuccess={() => updateRows({ remove: [data] })}
      buttonElement={
        <Typography color={Color.DANGER} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
          <TrashSimple />
        </Typography>
      }
    />
  );
};
